import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'

export default function RatingBar({ size = '2x', edit, stars, onChange }) {
  return (
    <div className="d-flex">
      {[1, 2, 3, 4, 5].map((star) => {
        const color = star <= stars ? 'text-secondary' : 'text-muted'

        return (
          <FontAwesomeIcon
            icon={faStar}
            size={size}
            className={`${color} me-3 cursor-pointer`}
            onClick={() => edit && onChange(star)}
            key={star}
          />
        )
      })}
    </div>
  )
}
